<template>
    <b-overlay :show="busy" rounded="sm">
        <!-- {{type}} -->
        <!-- {{ value }} -->
        <b-card class="standardpage border-none ">

            <div class="mt-2 availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0 px-0">

                        <b-tabs class="gridtabs" v-model="tabIndex">
                            <b-tab active>
                                <template #title>
                                    <i :class="blinvoice.icon" class="text-primary mr-1"></i>
                                    <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit"
                                        }}&gt;</span>
                                    <span class="strong"> Adjustment {{ type }} {{ value.referenceno }}</span>

                                </template>

                                <p class="mt-0">
                                    <b-row>
                                        <b-col>
                                            <b-alert :show="true" variant="secondary">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6"> Adjustment...
                                                        </span></b-col></b-row>
                                            </b-alert></b-col>
                                    </b-row>

                                    <b-row class="my-2">
                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                                                <treeselect placeholder="Select blac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="blac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="readonly">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col> -->
                                        <b-col cols="12" sm="6" md="4" xl="3">

                                            <b-form-group label-cols="12" label="Issue Date" label-size="sm">
                                                <b-input-group class="treeselect_all" style="left:60px; top:-13px">
                                                    <i id="date_at" class="fa fa-info-circle text-black"></i>
                                                </b-input-group>
                                                <b-tooltip target="date_at" triggers="hover" placement="top">BL Date
                                                </b-tooltip>
                                                <b-input-group>
                                                    <daterangepicker class="w-auto" size="sm" ref="date_at"
                                                        v-model="date_at" :opens="'right'" :locale-data="locale_data"
                                                        :ranges="false" :showDropdowns="true"
                                                        :single-date-picker="'true'" :disabled="readonly"
                                                        @update="edited = true">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="date_at = {
                                                                startDate: null,
                                                                endDate: null,
                                                            }
                                                                ">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>

                                    <b-overlay opacity="0.3" :show="!date_at">
                                        <template #overlay>
                                            <b-icon icon=""></b-icon>

                                        </template>
                                        <div class="mt-0 mb-1 text-center nested availtable datatable smallinputs">
                                            <table
                                                class="w-100pct table b-table table-striped table-hover table-sm mb-1"
                                                style="table-layout:fixed">
                                                <!-- <tr class="header-dark"> -->
                                                <tr class="header-primary text-white">

                                                    <td colspan="2" class="text-center w-55px">Lines </td>

                                                    <td class="text-center w-15pct"
                                                        v-if="columns.includes('adjustment_type')">
                                                        Adjustment Type</td>

                                                    <td class="text-center w-15pct"
                                                        v-if="columns.includes('blac_from')">
                                                        BL A/C From
                                                    </td>

                                                    <td class="text-center w-15pct" v-if="columns.includes('blac_to')">
                                                        BL A/C To
                                                    </td>

                                                    <td class="text-center w-25pct"
                                                        v-if="columns.includes('description')">
                                                        Description
                                                    </td>
                                                    <td class="text-right w-10pct" v-if="columns.includes('ticketno')">
                                                        Tkt/Ref </td>

                                                    <td class="text-center w-50px" v-if="columns.includes('qty')"> Qty
                                                    </td>

                                                    <td class="text-right w-110px" v-if="columns.includes('price')">
                                                        Price
                                                    </td>
                                                    <td class="text-right w-50px" v-if="columns.includes('vatrate')">
                                                        VAT
                                                        Rate
                                                    </td>
                                                    <td class="text-right w-110px" v-if="columns.includes('vat')"> VAT
                                                    </td>

                                                    <td class="text-right w-110px pr-2"
                                                        v-if="columns.includes('total')"> Total </td>


                                                    <td role="columnheader" scope="col" aria-colindex="1"
                                                        class="table-b-table-default text-center w-25px">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td colspan="6"></td>

                                                </tr>
                                                <tbody role="rowgroup">
                                                    <tr v-for="(line, index) in lines" :key="index">


                                                        <td class="w-25px">
                                                            <span class="small text-primary">{{ index + 1 }}.</span>
                                                        </td>
                                                        <td class="w-30px">
                                                            <i :class="blinvoice.icon" class="mr-2"></i>
                                                        </td>

                                                        <td v-if="columns.includes('adjustment_type')">
                                                            <b-form-group class="">
                                                                <b-input-group>
                                                                    <!-- @input="nlcode_update(index); edited = true" -->
                                                                    <treeselect instanceId="adjustment"
                                                                        v-model="line.adjustment_type" :clearable="true"
                                                                        :options="adjustment_type_options"
                                                                        :multiple="false" class="h-20px">
                                                                    </treeselect>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>

                                                        <td v-if="columns.includes('blac_from')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <treeselect placeholder="Select BL A/C..."
                                                                        searchPromptText="Type at least 4 chars..."
                                                                        v-model="line.blac_from" :clearable="true"
                                                                        :multiple="false" :async="true"
                                                                        :load-options="treeselect_loadBLAC"
                                                                        :show-count="true"
                                                                        :flatten-search-results="true"
                                                                        :disable-branch-nodes="true" :matchKeys="['id']"
                                                                        search-nested @select="edited = true">
                                                                        <div slot="value-label" slot-scope="{ node }">
                                                                            {{ node.raw.id }}
                                                                        </div>
                                                                    </treeselect>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>

                                                        <td v-if="columns.includes('blac_to')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <treeselect placeholder="Select BL A/C..."
                                                                        searchPromptText="Type at least 4 chars..."
                                                                        v-model="line.blac_to" :clearable="true"
                                                                        :multiple="false" :async="true"
                                                                        :load-options="treeselect_loadBLAC"
                                                                        :show-count="true"
                                                                        :flatten-search-results="true"
                                                                        :disable-branch-nodes="true" :matchKeys="['id']"
                                                                        search-nested @select="edited = true">
                                                                        <div slot="value-label" slot-scope="{ node }">
                                                                            {{ node.raw.id }}
                                                                        </div>
                                                                    </treeselect>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>

                                                        <td v-if="columns.includes('description')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.description"
                                                                        class="text-left text-uppercase"></b-form-input>
                                                                    <b-input-group-append>
                                                                        <b-button size="sm" variant="outline-secondary"
                                                                            @click="line.description = ''"
                                                                            placeholder="Description">
                                                                            <i class="fa fa-remove"></i>
                                                                        </b-button>
                                                                    </b-input-group-append>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>

                                                        <td v-if="columns.includes('ticketno')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.ticketno"
                                                                        placeholder="Tkt/Ref"
                                                                        class="text-right"></b-form-input>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>
                                                        <td v-if="columns.includes('qty')" class="w-5pct">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.qty"
                                                                        placeholder="Qty" type="text" class="text-right"
                                                                        :formatter="nocomma"
                                                                        :disabled="false"></b-form-input>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>

                                                        <td class="" v-if="columns.includes('price')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.price"
                                                                        placeholder="Cost" class="text-right"
                                                                        :formatter="nocomma"></b-form-input>
                                                                    <b-input-group-append>
                                                                        <b-button size="sm" variant="outline-secondary"
                                                                            @click="line.price = '0.00'"
                                                                            :disabled="line.price == '0.00'">
                                                                            <i class="fa fa-remove"></i>
                                                                        </b-button>
                                                                    </b-input-group-append>
                                                                </b-input-group>

                                                            </b-form-group>
                                                        </td>

                                                        <td v-if="columns.includes('vatrate')">
                                                            <b-form-group class="">
                                                                <b-input-group>
                                                                    <treeselect id="vatrate"
                                                                        placeholder="Select vat rate" :clearable="false"
                                                                        v-model="line.vatrate"
                                                                        :options="options_vatrates"
                                                                        :disable-branch-nodes="true" :show-count="true">
                                                                        <div slot="value-label" slot-scope="{ node }">
                                                                            {{ node.raw.id }}
                                                                        </div>
                                                                    </treeselect>

                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>
                                                        <td v-if="columns.includes('vat')">
                                                            <b-form-group class="">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.vat"
                                                                        placeholder="VAT" class="text-right"
                                                                        :formatter="nocomma"
                                                                        :disabled="true"></b-form-input>
                                                                    <b-input-group-append>
                                                                        <b-button size="sm" variant="outline-secondary"
                                                                            @click="line.vat = '0.00'" :disabled="true">
                                                                            <i class="fa fa-remove"></i>
                                                                        </b-button>
                                                                    </b-input-group-append>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>

                                                        <td class="w-30pct" v-if="columns.includes('airline')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.airline"
                                                                        placeholder="Airline / Supplier"
                                                                        class="text-left"></b-form-input>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>

                                                        <td class="w-30pct" v-if="columns.includes('bltype')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.bltype"
                                                                        placeholder="Supplier Type"
                                                                        class="text-left"></b-form-input>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>
                                                        <td class="w-30pct" v-if="columns.includes('bspref')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.bspref"
                                                                        placeholder="BSP Ref"
                                                                        class="text-left"></b-form-input>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>

                                                        <td class="w-10pct" v-if="columns.includes('comm')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.comm"
                                                                        placeholder="Commission" class="text-right"
                                                                        :formatter="nocomma"
                                                                        @change="edited = true"></b-form-input>
                                                                    <b-input-group-append>
                                                                        <b-button size="sm" variant="outline-secondary"
                                                                            @click="line.comm = '0.00'"
                                                                            :disabled="line.comm == '0.00'">
                                                                            <i class="fa fa-remove"></i>
                                                                        </b-button>
                                                                    </b-input-group-append>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>
                                                        <td class="w-8pct" v-if="columns.includes('rate')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.rate"
                                                                        placeholder="Commission Rate" class="text-right"
                                                                        :formatter="nocomma"
                                                                        @change="edited = true"></b-form-input>
                                                                    <b-input-group-append>
                                                                        <b-button size="sm" variant="outline-secondary"
                                                                            @click="line.rate = '0.00'"
                                                                            :disabled="line.rate == '0.00'">
                                                                            <i class="fa fa-remove"></i>
                                                                        </b-button>
                                                                    </b-input-group-append>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>
                                                        <td class="w-30pct" v-if="columns.includes('datetravel')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.datetravel"
                                                                        placeholder="DateTravel"
                                                                        class="text-left"></b-form-input>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>
                                                        <td class="w-30pct" v-if="columns.includes('invoiceno')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.invoiceno"
                                                                        placeholder="InvoiceNo"
                                                                        class="text-left"></b-form-input>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>
                                                        <td class="w-30pct" v-if="columns.includes('due')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.due"
                                                                        placeholder="Due"
                                                                        class="text-left"></b-form-input>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>
                                                        <td class="w-30pct" v-if="columns.includes('passenger')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.passenger"
                                                                        placeholder="Passenger"
                                                                        class="text-left"></b-form-input>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>
                                                        <td class="w-30pct" v-if="columns.includes('route')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.route"
                                                                        placeholder="Route"
                                                                        class="text-left"></b-form-input>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>
                                                        <td v-if="columns.includes('slac')">
                                                            <b-form-group class="">
                                                                <b-input-group>
                                                                    <treeselect instanceId="slac" type="number"
                                                                        v-model="line.slac" :clearable="true"
                                                                        :load-options="treeselect_loadSLAC"
                                                                        :multiple="false" class="h-20px"
                                                                        @select="edited = true">
                                                                    </treeselect>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>

                                                        <td class="w-10pct" v-if="columns.includes('unittaxes')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.unittaxes"
                                                                        placeholder="Unit Taxes" class="text-right"
                                                                        :formatter="nocomma"
                                                                        @change="edited = true"></b-form-input>
                                                                    <b-input-group-append>
                                                                        <b-button size="sm" variant="outline-secondary"
                                                                            @click="line.unittaxes = '0.00'"
                                                                            :disabled="line.unittaxes == '0.00'">
                                                                            <i class="fa fa-remove"></i>
                                                                        </b-button>
                                                                    </b-input-group-append>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>
                                                        <td class="w-10pct" v-if="columns.includes('unitexvat')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.unitexvat"
                                                                        placeholder="Unit Ex Vat" class="text-right"
                                                                        :formatter="nocomma"
                                                                        @change="edited = true"></b-form-input>
                                                                    <b-input-group-append>
                                                                        <b-button size="sm" variant="outline-secondary"
                                                                            @click="line.unitexvat = '0.00'"
                                                                            :disabled="line.unitexvat == '0.00'">
                                                                            <i class="fa fa-remove"></i>
                                                                        </b-button>
                                                                    </b-input-group-append>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>
                                                        <td class="w-10pct" v-if="columns.includes('linetotal')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.linetotal"
                                                                        placeholder="Unit Total" class="text-right"
                                                                        :formatter="nocomma"
                                                                        @change="edited = true"></b-form-input>
                                                                    <b-input-group-append>
                                                                        <b-button size="sm" variant="outline-secondary"
                                                                            @click="line.linetotal = '0.00'"
                                                                            :disabled="line.linetotal == '0.00'">
                                                                            <i class="fa fa-remove"></i>
                                                                        </b-button>
                                                                    </b-input-group-append>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>

                                                        <td class="w-10pct" v-if="columns.includes('total')">
                                                            <b-form-group class="mb-3px">
                                                                <b-input-group>
                                                                    <b-form-input size="sm" v-model="line.total"
                                                                        placeholder="Amount" class="text-right"
                                                                        :formatter="nocomma" :disabled="true"
                                                                        @change="edited = true"></b-form-input>
                                                                    <b-input-group-append>
                                                                        <b-button size="sm" variant="outline-secondary"
                                                                            @click="line.total = '0.00'"
                                                                            :disabled="true">
                                                                            <i class="fa fa-remove"></i>
                                                                        </b-button>
                                                                    </b-input-group-append>
                                                                </b-input-group>
                                                            </b-form-group>
                                                        </td>
                                                        <td :id="'lines-del_' + index" class="w-30px"
                                                            style="padding-left:5px !important;">
                                                            <b-input-group class="m-auto w-15px">
                                                                <i class="fa fa-trash text-danger font-14px"
                                                                    @click="delLine(index + 1)"></i>
                                                                <b-tooltip :target="'lines-del_' + index"
                                                                    placement="top">Del
                                                                    line</b-tooltip>
                                                                <!-- <input id="lineCheck" style="height: 12px" type="checkbox" v-model="lines"
                        @click="toggleLine($event, index)" :checked="true" :value="line"
                        :disabled="value.lines.length == 1 || line.fare == 'N/A' || value.lines.filter(o => o.fare != 'N/A').length == 1" /> -->

                                                            </b-input-group>
                                                        </td>
                                                    </tr>
                                                </tbody>

                                                <!-- <tr class="h-30px">
                                            <td :id="'lines-add_' + value.id" class="w-30px">
                                                <i class="fa fa-plus-square text-primary font-14px "
                                                    @click="addLine"></i>
                                                <b-tooltip :target="'lines-add_' + value.id" placement="top">Add
                                                    line</b-tooltip>
                                            </td>

                                            <td colspan="12">
                                            </td>
                                        </tr> -->

                                            </table>
                                            <table class="w-100pct table">
                                                <tr>
                                                    <td width="50%" class="text-left pt-0 border-top-none pl-0">
                                                        <b-row>
                                                            <b-col cols="12">
                                                                <b-form-group label="Notes">
                                                                    <b-form-textarea id="data" v-model="notes" rows="5"
                                                                        max-rows="5" class="smalltextarea"
                                                                        :disabled="false"></b-form-textarea>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>
                                                    </td>
                                                    <td width="50%" class="text-left pt-1 border-top-none">
                                                        <table class="w-100pct table">
                                                            <tr>
                                                                <td class="pr-1 text-left border-top-none"><span
                                                                        class="h6 text-2x">Net</span>
                                                                </td>
                                                                <td class="pl-1 text-right pt-1 border-top-none">
                                                                    <span class="text-2x">{{ subtotal }}</span>
                                                                </td>
                                                            </tr>
                                                            <tr v-if="parseFloat(vat) != 0">
                                                                <td
                                                                    class="pr-1 text-left border-top-none border-bottom">
                                                                    <span class="text-2x h6 strong">VAT</span>
                                                                </td>
                                                                <td
                                                                    class="strong pl-1 text-right pt-1 border-top-none border-bottom">
                                                                    <span class="text-2x">{{ vat }}</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td
                                                                    class="pr-1 text-left border-top-none border-bottom">
                                                                    <span class="h6 strong text-2x">Total</span>
                                                                </td>

                                                                <td
                                                                    class="h6 strong pl-1 text-right pt-1 border-top-none border-bottom">
                                                                    <span class="text-2x">{{ total }}</span>

                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </table>

                                            <b-row no-gutters>
                                                <b-col cols="auto" class="mr-3">
                                                    <b-button squared size="sm" variant="primary" @click="postit_saveit"
                                                        v-if="user.permissions.includes('boughtledger.save')"
                                                        :disabled="postit_disabled">
                                                        <i class="fa fa-check"></i>
                                                        Post It
                                                    </b-button>
                                                </b-col>
                                                <b-col class="text-left my-auto">
                                                    <div v-if="busy">
                                                        <i class="fa fa-spinner fa-spin text-primary"></i>
                                                    </div>
                                                    <div v-else>
                                                        <span v-html="message"></span>
                                                    </div>
                                                </b-col>
                                            </b-row>



                                        </div>
                                    </b-overlay>
                                </p>

                            </b-tab>

                            <b-tab>
                                <template #title>
                                    <i class="fa fa-upload text-primary mr-1"></i>
                                    <span class="strong"> Loader</span>

                                </template>
                                <div>
                                    <i-loaderbl>
                                    </i-loaderbl>
                                </div>


                            </b-tab>



                            <b-tab v-if="1 == 0">
                                <template #title>
                                    <i class="fa fa-history text-primary mr-1"></i>Audit
                                </template>

                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="value.created_at"
                                                            button-only label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="value.created_at"
                                                        type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="value.created_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="value.created_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="value.created_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="value.updated_at"
                                                            button-only label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="value.updated_at"
                                                        type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="value.updated_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="value.updated_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="value.updated_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>

                        </b-tabs>

                    </b-card-body>
                </b-card>
            </div>

            <b-card-footer class="mt-2 ml-1">
                <b-row>
                    <b-col class="text-right">
                        <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
                            <i class="fa fa-chevron-left pr-1"></i>Back
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-footer>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "BLAdjustments",
    props: {
        value: { type: Object, required: true },
    },
    watch: {
        value: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.lines = newVal.items
                this.edited = false
            }
        },
        lines: {
            immediate: true,
            deep: true,
            async handler(newVal, oldVal) {
                this.postit_ready()
            }
        },
        bltype: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.postit_ready()
            }
        },
        blac: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.postit_ready()
            }
        },
        eventcode: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.postit_ready()
            }
        },
        type: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.postit_ready()
            }
        }
    },
    async mounted() { },
    data() {
        return {
            busy: false,
            tabIndex: 0,
            edited: false,
            readonly: false,
            posted: false,
            message: "",
            adjustment_type: null,
            blac_from: null,
            blac_to: null,
            notes: null,
            // type: 'invoice',
            // yourref: null,
            // route: null,
            date_at: {
                startDate: this.$moment().format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            // due_at: {
            //     startDate: this.$moment().add(1, 'month').format("YYYY-MM-DD"),
            //     endDate: this.$moment().add(1, 'month').format("YYYY-MM-DD"),
            // },
            columns: ['adjustment_type', 'blac_from', 'blac_to', 'description', 'ticketno', 'qty', 'price', 'vatrate', 'vat', 'total'],
            columns_options: [
                {
                    id: 'adjustment_type',
                    label: 'Adjustment Type'
                },
                {
                    id: "blac_from",
                    label: "BL A/C From"
                },
                {
                    id: "blac_to",
                    label: "BL A/C To"
                },
                {
                    id: 'description',
                    label: 'Description'
                },
                {
                    id: 'ticketno',
                    label: 'Tkt/Ref'
                },
                {
                    id: 'airline',
                    label: 'Airline / Supplier'
                },
                /*typeref?*/
                {
                    id: 'bltype',
                    label: 'Supplier Type'
                },
                {
                    id: "bspref",
                    label: "BSP Ref"
                },
                {
                    id: 'comm',
                    label: 'Commission'
                },
                {
                    id: 'datetravel',
                    label: 'DateTravel'
                },
                {
                    id: 'invoiceno',
                    label: 'InvoiceNo'
                },
                {
                    id: 'due',
                    label: 'Due'
                },


                // {
                //     id: 'qty',
                //     label: 'Qty'
                // },
                {
                    id: 'rate',
                    label: 'Commission Rate'
                },
                {
                    id: 'route',
                    label: 'Route'
                },
                {
                    id: 'slac',
                    label: 'Client SL A/C'
                },

                {
                    id: "unitcost",
                    label: "Unit Cost"
                },
                {
                    id: "unittaxes",
                    label: "Unit Taxes"
                },
                {
                    id: "unitexvat",
                    label: "Unit Ex Vat"
                },
                /*costtotal??? */
                {
                    id: 'linetotal',
                    label: 'Unit Total'
                },
                {
                    id: "vatrate",
                    label: "VAT Rate"
                },
                {
                    id: "vat",
                    label: "VAT"
                }
            ],
            adjustment_type_options: [
                { id: "I", label: "I | Invoice" },
                { id: "A", label: "A | Adjustment" },
                { id: "P", label: "P | Payment" },
            ],
            postit_disabled: true,
            lines: [],
            blinvoice: {
                icon: "fa fa-pie-chart text-secondary",
                debounce: 500,
                toolbarlibrary: [{
                    type: "button",
                    size: "sm",
                    variant: "outline-white",
                    squared: "squared",
                    icon: "fa fa-play text-primary",
                    position: "toolbar",
                    action: "refresh",
                    label: "Go",
                },
                {
                    type: "button",
                    size: "sm",
                    variant: "outline-white",
                    squared: "squared",
                    icon: "fa fa-filter text-primary",
                    position: "toolbar",
                    action: "filter",
                    label: "Filter",
                    component: {
                        name: "",
                    },
                },],
            },
            subtotal: "0.00",
            vat: "0.00",
            total: "0.00"
        };
    },
    methods: {
        onlyascii(value) {
            // A SPECIFIC REPLACE
            value = value.split('b').join('')
            value = value.normalize('NFD').replace(/([\u0300-\u036f]|[^\x20-\x7E])/g, '')
            return value
        },
        linesAll(evt) {
            const list = this.allLinesChecked
                ? []
                : this.value.lines.slice(0, this.value.lines.length);
            this.lines = list;
        },
        toggleLine(evt, index) {
            console.log("toggleLine", evt, index);

            const savedIndex = this.savedIndex;
            this.savedIndex = index;

            // If this is the first pass or no shift key was
            // pressed, just bail.
            if (savedIndex === null || !evt.shiftKey) return;

            // Shift-clicked the same message :-/
            if (index === savedIndex) return;

            // Get the subset of the message list between the
            // two indicies.
            // console.time("toggle range");
            const subset = this.items.slice(
                Math.min(index, savedIndex),
                Math.max(index, savedIndex) + 1
            );
            // Determine the operation based on the checked state
            // of the clicked checkbox.
            const toggleFn = evt.currentTarget.checked
                ? addCheckedSubset
                : removeCheckedSubset;

            this.lines = toggleFn(this.lines, subset);
            console.log("these are checked", this.lines);
            // console.timeEnd("toggle range");
        },
        addLine() {
            let _copy = { ...this.lines[this.lines.length - 1] }
            _copy.id = null
            _copy.bltype = null
            _copy.nlcode = null
            _copy.eventcode = null
            _copy.description = null
            _copy.ticketno = null
            _copy.price = (0).toFixed(2)
            _copy.vat = (0).toFixed(2)
            _copy.total = (0).toFixed(2)
            this.lines.push(_copy)
            this.edited = true
        },
        async delLine(index) {
            if (await this.$bvModal.msgBoxConfirm('Are you sure you want to delete blinvoice line ' + index + '?',
                {
                    title: 'Please confirm delete action.',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })) {

                let result = []
                for (var j = 0; j < this.lines.length; ++j) {
                    if (j != index - 1) {
                        result.push(this.lines[j])
                    }
                }
                this.lines = result
                this.edited = true
            }
        },
        async nlcode_update(index) {
            let pick = this.supply_options.find(k => k.id == this.lines[index].bltype);
            if (pick) {
                this.lines[index].nlcode = pick.costsnl
            } else {
                this.lines[index].nlcode = null
            }
        },
        async postit_saveit() {
            console.log('postit_saveit')

            this.busy = true

            let rows = []
            for (var j = 0; j < this.lines.length; ++j) {

                let lineitem = this.lines[j]

                if (parseFloat(lineitem.total) != 0) {

                    let factor = this.type == 'credit' ? -1 : 1

                    //PREPARE NEW BOUGHT LEDGER ENTRY
                    let blentry = {
                        credit: this.type == 'credit' ? true : false,
                        prefix: lineitem.type,
                        line: (j + 1).toString(),

                        blac: this.blac,
                        eventcode: lineitem.eventcode,

                        costnl: lineitem.nlcode,
                        passenger: lineitem.description,
                        ticketno: lineitem.ticketno,
                        qty: lineitem.qty,

                        // REVIEW FROM HERE
                        taxes: "0.00",
                        costticket: (parseFloat(lineitem.price) * factor).toFixed(2),
                        costexvat: (parseFloat(lineitem.price) * factor).toFixed(2),
                        costvat: (parseFloat(lineitem.vat) * factor).toFixed(2),
                        costtotal: (parseFloat(lineitem.total) * factor).toFixed(2),
                        due: (parseFloat(lineitem.total) * factor).toFixed(2),

                        notes: this.notes,
                        yourref: this.yourref,
                        route: this.route
                    }
                    rows.push(blentry)
                }

            }

            let variables = { rows };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation BL_save(
                            $rows: [BLTransaction_input]
                        ) {
                            BL_save(rows: $rows) {
                                id
                                invoiceno
                        }
                        }
                    `,
                    variables,
                });

                if (response.data.BL_save.length > 0) {

                    this.message = "<span class='text-primary'>Saved it. " + response.data.BL_save[0].invoiceno + "</span>";
                    // this.value.referenceno = response.data.BL_save[0].referenceno
                }

                this.edited = false
                this.posted = true

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false
        },
        postit_ready() {
            console.log('postit_ready')

            this.value.type = this.type == 'invoice' ? 'IG' : 'CG'
            this.value.referenceno = this.value.type + '*new*'

            let subtotal = 0
            let vat = 0
            let total = 0

            if (!this.blac) {
                this.postit_disabled = true
                return
            }

            for (var k = 0; k < this.lines.length; k++) {
                let line = this.lines[k]

                line.type = this.value.type
                line.referenceno = this.value.referenceno
                line.blac = this.blac

                if (line.description) {
                    line.description = line.description.toUpperCase()
                }
                if (line.ticketno) {
                    line.ticketno = line.ticketno.toUpperCase()
                }
                if (line.price) {

                    switch (line.vatrate) {
                        case "S":
                            line.vat = (parseFloat(line.total) * 0.2).toFixed(2)
                            break;
                        default:
                            line.vat = "0"
                    }
                    if (line.vat) {
                        vat += parseFloat(line.vat)
                    }
                    line.total = (parseFloat(line.price) + parseFloat(line.vat)).toFixed(2)
                }

                if (line.total) {
                    subtotal += parseFloat(line.total)
                }
            }
            this.subtotal = (subtotal).toFixed(2)
            this.vat = (vat).toFixed(2)
            this.total = (subtotal + vat).toFixed(2)

            if (this.lines.length > 0) {
                if (this.lines[this.lines.length - 1].nlcode && parseFloat(this.lines[this.lines.length - 1].total) != 0) {
                    this.addLine()
                }
                for (var k = 0; k < this.lines.length; k++) {
                    let line = this.lines[k]
                    if (parseFloat(line.price) > 0 && !line.eventcode) {
                        this.message = "<span class='text-danger'>" + "Line " + (k + 1) + ". requires a valid event!" + "</span>"
                        this.postit_disabled = true
                        return
                    }
                }
                this.message = ""
                this.postit_disabled = false
            }

        },


    },
};
</script>